const VALID_COUNTER_TYPES = ['Long', 'Double', 'Integer'];
const INVALID_COUNTER_NAMES = {
  ga1: [],
  ga2: ['activebeam', 'events_time_since_boot', 'sysuptime', 'systemuptime'],
  unknown: []
};

export function toAvailableCountersPayload({ source, from, to }) {
  return {
    sourceType: source,
    searchSpan: toSearchSpan({ from, to })
  };
}

export function fromAvailableCountersResult({ properties = [] }, gaVersion = 'ga1') {  
  const invalidCounters = INVALID_COUNTER_NAMES[gaVersion.toLowerCase()];
  return Object.values(
    properties.reduce((acc, { name, type, _metadata }) => {
      if (
        !acc[name] &&
        VALID_COUNTER_TYPES.includes(type) &&
        !name.startsWith('[') &&
        !invalidCounters.includes(name.toLowerCase())
      ) {
        acc[name] = {
          label: _metadata?.uiFriendlyName ?? name,
          value: name,
          metadata: _metadata
        };
      }

      return acc;
    }, {})
  );
}

export function toCountersPayload({ devices, counters, from, to, interval, suffix }) {
  return {
    devices: toDeviceIds(devices, suffix),
    counters,
    resolution: interval,
    searchSpan: toSearchSpan({ from, to })
  };
}

export function fromCountersResult({ aggregates = [] }, { counters }) {
  const [deviceData = {}] = aggregates;
  const { dimension = [], measures = [] } = deviceData;

  return dimension.map((date, dateIndex) =>
    counters.reduce(
      (acc, counter, counterIndex) => {
        const measure = measures[dateIndex] ?? [];
        acc[counter.name] = measure[counterIndex] ?? null;

        return acc;
      },
      { timestamp: new Date(date) }
    )
  );
}

export function toSearchSpan({ from, to }) {
  return {
    from: {
      dateTime: new Date(from).toISOString()
    },
    to: {
      dateTime: new Date(to).toISOString()
    }
  };
}

export function toDeviceIds(devices, suffix) {
  if (!suffix || suffix === '') return devices;
  let modifiedDeviceIds = devices.map((device) => device + suffix);
  if (suffix.includes('du')) {
    modifiedDeviceIds.push(devices[0] + '_/allsector')
  } else if (suffix.includes('su')) { // _/su1, _/su2
    const sectorNum = suffix.match(/\d+$/);
    modifiedDeviceIds.push(devices[0] + `_/sector${sectorNum}`);
  }

  return modifiedDeviceIds;
}
